import React, { useEffect, useState, lazy, memo } from 'react';
import { ArrowRightIcon, ClockIcon, ShieldCheckIcon, TruckIcon, AlertTriangleIcon, TimerIcon, CreditCardIcon, ShieldIcon, CheckCircleIcon, ChevronRightIcon, ZapIcon, XIcon } from 'lucide-react';
import { trackInitiateCheckout } from './MetaPixel';
const CTASection = () => {
  const handleCheckoutClick = () => {
    // Registrar evento de InitiateCheckout cuando se hace clic en el botón de compra
    trackInitiateCheckout();
    // Abrir el checkout en la misma página
    window.location.href = 'https://shopysv.com/products/pide-tu-gorro-anti-migrana';
  };
  // Estado para el contador de stock
  const [stockCount, setStockCount] = useState(12);
  // Estado para el contador regresivo
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 59,
    seconds: 59
  });
  // Estado para la notificación de última oportunidad
  const [showLastChance, setShowLastChance] = useState(false);
  // Efecto para el contador regresivo
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        } else {
          // Reiniciar cuando llegue a 0
          return {
            hours: 2,
            minutes: 59,
            seconds: 59
          };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Efecto para reducir el stock aleatoriamente
  useEffect(() => {
    const stockTimer = setInterval(() => {
      setStockCount(prevStock => {
        // Reducir stock aleatoriamente entre 1-2 unidades
        const reduction = Math.floor(Math.random() * 2) + 1;
        const newStock = Math.max(prevStock - reduction, 3); // No bajar de 3 unidades
        return newStock;
      });
    }, 45000); // Cada 45 segundos
    return () => clearInterval(stockTimer);
  }, []);
  // Mostrar notificación después de 20 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLastChance(true);
    }, 20000);
    return () => clearTimeout(timer);
  }, []);
  // Función para cerrar la notificación
  const closeLastChance = () => {
    setShowLastChance(false);
  };
  // Ventajas del producto
  const advantages = ['Alivia el dolor sin medicamentos', 'Tecnología de frío/calor avanzada', 'Diseño ergonómico para máxima comodidad', 'Resultados desde las primeras aplicaciones', 'Ideal para migrañas, dolores de cabeza y tensión'];
  return <section className="py-16 md:py-24 bg-gradient-to-b from-white to-[#eef2ff]" data-id="element-78">
      <div className="container mx-auto px-4 md:px-6" data-id="element-79">
        <div className="max-w-4xl mx-auto" data-id="element-80">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-81">
            <div className="p-8 md:p-12" data-id="element-82">
              <div className="text-center mb-8" data-id="element-83">
                <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#1e293b]" data-id="element-84">
                  Las unidades son limitadas
                </h2>
                {/* Contador regresivo */}
                <div className="mb-6" data-id="element-85">
                  <p className="text-[#4a5568] font-medium mb-3" data-id="element-86">
                    La oferta expira en:
                  </p>
                  <div className="flex justify-center space-x-2" data-id="element-87">
                    <div className="flex flex-col items-center" data-id="element-88">
                      <div className="bg-[#1e293b] text-white text-xl font-bold rounded-md w-16 h-16 flex items-center justify-center" data-id="element-89">
                        {timeLeft.hours.toString().padStart(2, '0')}
                      </div>
                      <span className="text-xs mt-1" data-id="element-90">Horas</span>
                    </div>
                    <div className="flex items-center justify-center" data-id="element-91">
                      <span className="text-xl font-bold" data-id="element-92">:</span>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-93">
                      <div className="bg-[#1e293b] text-white text-xl font-bold rounded-md w-16 h-16 flex items-center justify-center" data-id="element-94">
                        {timeLeft.minutes.toString().padStart(2, '0')}
                      </div>
                      <span className="text-xs mt-1" data-id="element-95">Min</span>
                    </div>
                    <div className="flex items-center justify-center" data-id="element-96">
                      <span className="text-xl font-bold" data-id="element-97">:</span>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-98">
                      <div className="bg-[#1e293b] text-white text-xl font-bold rounded-md w-16 h-16 flex items-center justify-center" data-id="element-99">
                        {timeLeft.seconds.toString().padStart(2, '0')}
                      </div>
                      <span className="text-xs mt-1" data-id="element-100">Seg</span>
                    </div>
                  </div>
                </div>
                <div className="bg-[#fff5f5] border-l-4 border-[#e53e3e] p-4 my-6 rounded-r-lg relative overflow-hidden animate-pulse" data-id="element-101">
                  <div className="absolute top-0 right-0 w-24 h-24 -mr-8 -mt-8 bg-[#fed7d7] rounded-full opacity-20" data-id="element-102"></div>
                  <div className="flex items-start" data-id="element-103">
                    <AlertTriangleIcon size={24} className="text-[#e53e3e] mr-3 shrink-0 mt-1" data-id="element-104" />
                    <div data-id="element-105">
                      <p className="text-xl text-[#4a5568] font-medium" data-id="element-106">
                        <span className="text-[#e53e3e] font-bold" data-id="element-107">
                          ¡ALERTA DE STOCK!
                        </span>{' '}
                        La demanda se ha
                        <span className="font-bold underline decoration-[#e53e3e] decoration-2 underline-offset-2" data-id="element-108">
                          {' '}
                          triplicado este mes
                        </span>
                        .
                      </p>
                      <div className="flex items-center mt-2" data-id="element-109">
                        <TimerIcon size={18} className="text-[#e53e3e] mr-2 animate-pulse" data-id="element-110" />
                        <p className="text-lg text-[#4a5568]" data-id="element-111">
                          Los envíos se están{' '}
                          <span className="font-bold" data-id="element-112">
                            agotando rápidamente
                          </span>{' '}
                          —
                          <span className="italic" data-id="element-113">
                            {' '}
                            quedan{' '}
                            <span className="font-bold text-[#e53e3e]" data-id="element-114">
                              {stockCount}
                            </span>{' '}
                            unidades disponibles
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Barra de progreso de stock */}
                <div className="my-6" data-id="element-115">
                  <div className="w-full bg-gray-200 rounded-full h-2.5 mb-2" data-id="element-116">
                    <div className="bg-red-500 h-2.5 rounded-full" style={{
                    width: `${stockCount / 50 * 100}%`
                  }} data-id="element-117"></div>
                  </div>
                  <p className="text-sm text-[#4a5568]" data-id="element-118">
                    <span className="font-medium" data-id="element-119">Stock restante:</span>{' '}
                    {stockCount}/50 unidades
                  </p>
                </div>
                <p className="text-xl text-[#4a5568] font-medium mt-4" data-id="element-120">
                  No es el momento de pensarlo. Es el momento de actuar.
                </p>
              </div>
              <div className="bg-[#f8f9ff] p-6 rounded-xl mb-8" data-id="element-121">
                <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-122">
                  <div className="md:w-1/2" data-id="element-123">
                    <div className="mb-6 relative" data-id="element-124">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sUmvxFwTqjtq3yfmKHNkqV/freepik__cambia-el-color-del-gorro-por-rosado-sin-alterar-n__98289.png" alt="Corona de Alivio 360 - Gorro rosa con tecnología de alivio" className="w-full h-auto rounded-lg shadow-md" width="500" height="400" loading="lazy" data-id="element-125" />
                      {/* Etiqueta de más vendido */}
                      <div className="absolute -top-3 -left-3 bg-[#f59e0b] text-white text-xs font-bold py-1 px-3 rounded-full transform -rotate-12 shadow-lg" data-id="element-126">
                        MÁS VENDIDO
                      </div>
                    </div>
                    <h3 className="text-2xl font-semibold mb-4 text-[#1e293b]" data-id="element-127">
                      Kit Completo de Alivio
                    </h3>
                    <ul className="space-y-3" data-id="element-128">
                      <li className="flex items-start" data-id="element-129">
                        <ShieldCheckIcon size={20} className="text-[#4ade80] mt-1 mr-3 shrink-0" data-id="element-130" />
                        <span className="text-[#4a5568]" data-id="element-131">
                          Gorro 360 con gel antimigraña
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-132">
                        <ShieldCheckIcon size={20} className="text-[#4ade80] mt-1 mr-3 shrink-0" data-id="element-133" />
                        <span className="text-[#4a5568]" data-id="element-134">
                          Úsalo frío (10-20 min) o caliente (10 min)
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-135">
                        <ShieldCheckIcon size={20} className="text-[#4ade80] mt-1 mr-3 shrink-0" data-id="element-136" />
                        <span className="text-[#4a5568]" data-id="element-137">
                          Garantía de satisfacción
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-138">
                        <ShieldCheckIcon size={20} className="text-[#4ade80] mt-1 mr-3 shrink-0" data-id="element-139" />
                        <span className="text-[#4a5568]" data-id="element-140">Envío rápido</span>
                      </li>
                    </ul>
                  </div>
                  <div className="md:w-1/2 text-center md:text-right" data-id="element-141">
                    <div className="mb-4" data-id="element-142">
                      <span className="text-[#a0aec0] line-through text-xl" data-id="element-143">
                        $50
                      </span>
                      <span className="text-3xl font-bold text-[#1e293b] ml-2" data-id="element-144">
                        $25
                      </span>
                      <span className="bg-[#4ade80] text-white text-xs px-2 py-1 rounded-full ml-2" data-id="element-145">
                        50% OFF
                      </span>
                    </div>
                    <div className="flex items-center justify-center md:justify-end text-[#4a5568] mb-6" data-id="element-146">
                      <TruckIcon size={18} className="mr-2 text-[#6366f1]" data-id="element-147" />
                      <span data-id="element-148">Envío gratis</span>
                      <ClockIcon size={18} className="ml-4 mr-2 text-[#6366f1]" data-id="element-149" />
                      <span data-id="element-150">Entrega: 24-48h</span>
                    </div>
                    <div className="bg-[#4ade80] text-white px-3 py-1 rounded-full inline-block text-sm font-medium animate-pulse" data-id="element-151">
                      Oferta por tiempo limitado
                    </div>
                  </div>
                </div>
              </div>
              {/* Lista de ventajas */}
              <div className="mb-8 bg-[#f0f9ff] p-4 rounded-lg" data-id="element-152">
                <h3 className="font-medium text-lg mb-3 text-[#1e293b]" data-id="element-153">
                  ¿Por qué elegir Corona de Alivio 360?
                </h3>
                <ul className="space-y-2" data-id="element-154">
                  {advantages.map((advantage, index) => <li key={index} className="flex items-start" data-id="element-155">
                      <ChevronRightIcon size={18} className="text-[#6366f1] mt-1 mr-2 shrink-0" data-id="element-156" />
                      <span className="text-[#4a5568]" data-id="element-157">{advantage}</span>
                    </li>)}
                </ul>
              </div>
              <div className="text-center" data-id="element-158">
                <button onClick={handleCheckoutClick} className="group bg-[#8b5cf6] hover:bg-[#7c3aed] text-white px-10 py-5 rounded-full text-xl font-medium transition-all transform hover:scale-105 shadow-lg w-full md:w-auto relative overflow-hidden" data-id="element-159">
                  <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-[#8b5cf6] to-[#6366f1] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-160"></span>
                  <span className="relative z-10 flex items-center justify-center" data-id="element-161">
                    Sí, quiero mi sesión de alivio AHORA{' '}
                    <ArrowRightIcon size={20} className="inline ml-2 group-hover:translate-x-1 transition-transform" data-id="element-162" />
                  </span>
                </button>
                {/* Contador de personas viendo el producto */}
                <div className="mt-4 flex items-center justify-center" data-id="element-163">
                  <div className="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse" data-id="element-164"></div>
                  <p className="text-sm text-[#4a5568]" data-id="element-165">
                    <strong data-id="element-166">28 personas</strong> están viendo esta oferta ahora
                    mismo
                  </p>
                </div>
                <p className="mt-6 text-[#718096] text-sm" data-id="element-167">
                  Pago seguro · 30 días de garantía · Soporte 24/7
                </p>
                {/* Logos de pago y garantía */}
                <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-168">
                  <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8" data-id="element-169">
                    <div className="flex items-center" data-id="element-170">
                      <ShieldIcon size={20} className="text-[#4ade80] mr-2" data-id="element-171" />
                      <span className="text-sm font-medium text-[#4a5568]" data-id="element-172">
                        Compra Segura
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-173">
                      <CheckCircleIcon size={20} className="text-[#4ade80] mr-2" data-id="element-174" />
                      <span className="text-sm font-medium text-[#4a5568]" data-id="element-175">
                        Garantía 30 días
                      </span>
                    </div>
                    <div className="flex items-center" data-id="element-176">
                      <img src="https://cdn.iconscout.com/icon/free/png-256/free-visa-3-226460.png" alt="Visa" className="h-8 w-auto" width="32" height="32" loading="lazy" data-id="element-177" />
                    </div>
                    <div className="flex items-center" data-id="element-178">
                      <img src="https://cdn.iconscout.com/icon/free/png-256/free-mastercard-3-226462.png" alt="Mastercard" className="h-8 w-auto" width="32" height="32" loading="lazy" data-id="element-179" />
                    </div>
                    <div className="flex items-center" data-id="element-180">
                      <CreditCardIcon size={20} className="text-[#4a5568] mr-2" data-id="element-181" />
                      <span className="text-sm font-medium text-[#4a5568]" data-id="element-182">
                        Pago Contra Entrega
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-8 text-center" data-id="element-183">
                <p className="text-lg text-[#4a5568] italic" data-id="element-184">
                  Porque ya no tienes dudas. Solo acción. Y algo dentro de ti...
                  lo sabe.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Notificación de última oportunidad */}
      {showLastChance && <div className="fixed bottom-4 right-4 bg-white p-4 rounded-lg shadow-xl border-l-4 border-[#f59e0b] max-w-sm z-50 animate-slideIn" data-id="element-185">
          <div className="flex items-start" data-id="element-186">
            <ZapIcon className="text-[#f59e0b] mr-3 mt-1 shrink-0" size={24} data-id="element-187" />
            <div className="flex-1" data-id="element-188">
              <div className="flex justify-between items-start" data-id="element-189">
                <h4 className="font-bold text-[#1e293b]" data-id="element-190">
                  ¡Última oportunidad!
                </h4>
                <button onClick={closeLastChance} className="text-gray-400 hover:text-gray-600" data-id="element-191">
                  <XIcon size={16} data-id="element-192" />
                </button>
              </div>
              <p className="text-[#4a5568] mt-1" data-id="element-193">
                El precio especial de $25 solo estará disponible por las
                próximas horas. ¡No pierdas esta oportunidad de alivio!
              </p>
              <button onClick={handleCheckoutClick} className="mt-3 bg-[#f59e0b] hover:bg-[#d97706] text-white py-2 px-4 rounded-lg text-sm font-medium w-full" data-id="element-194">
                Aprovechar oferta ahora
              </button>
            </div>
          </div>
        </div>}
      <style jsx data-id="element-195">{`
        @keyframes slideIn {
          0% {
            transform: translateX(100%);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }
        .animate-slideIn {
          animation: slideIn 0.5s ease-out forwards;
        }
      `}</style>
    </section>;
};
export default memo(CTASection);